var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Modal, TextField, Form, Spinner, useShowFlag, GrayText, } from "@atlassiansox/microscopekit";
import React, { useState } from "react";
import SearchIcon from "@atlaskit/icon/glyph/search";
import { PanelList } from "./panel-list";
import { usePanels, useSearch } from "../hooks";
import styled from "styled-components"; // tslint:disable-line
var SearchModalWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n"], ["\n  padding-top: 20px;\n"])));
var SearchIconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 6px;\n"], ["\n  padding: 6px;\n"])));
var searchIcon = (React.createElement(SearchIconWrapper, null,
    React.createElement(SearchIcon, { label: "search" })));
export var PanelSearchView = function (props) {
    var _a = useState(""), text = _a[0], setText = _a[1];
    var _b = useSearch(props.id), panels = _b.panels, updateQuery = _b.updateQuery, loading = _b.loading;
    var _c = usePanels(props.id), installedPanels = _c.panels, refetch = _c.refetch;
    var showFlag = useShowFlag();
    return (React.createElement(React.Fragment, null,
        React.createElement(Form, { onSubmit: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    updateQuery(text);
                    return [2 /*return*/];
                });
            }); } },
            React.createElement(TextField, { onChange: function (e) {
                    setText(e.target.value);
                }, value: text, name: "searchBox", placeholder: "Search for a panel by name/description/owner", elemBeforeInput: searchIcon })),
        React.createElement(SearchModalWrapper, null,
            loading && React.createElement(Spinner, null),
            !loading && !panels.length && (React.createElement(GrayText, null, "No panel found. Please try a different query.")),
            React.createElement(PanelList, { serviceId: props.id, panels: panels.filter(function (p) {
                    var ip = installedPanels
                        .map(function (p) { return p.name; })
                        .find(function (name) { return name === p.name; });
                    return !ip;
                }), onInstallSuccess: function (p) {
                    refetch();
                    showFlag({
                        title: "Installed Panel successfully",
                        message: "Panel " + p.name + " is installed on your service. The panel may not be immediately accessible. It may take up to 15 minutes to sync the permissions",
                        type: "success",
                    });
                }, onInstallFailure: function (panelName, e) {
                    showFlag({
                        title: "Failed to install Panel " + panelName,
                        message: e.message,
                        type: "error",
                    });
                } }))));
};
export var SearchModal = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose;
    return (React.createElement(Modal, { width: "x-large", height: "100vh", isOpen: isOpen, actions: [
            {
                text: "Cancel",
                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        onClose();
                        return [2 /*return*/];
                    });
                }); },
            },
        ], onClose: onClose, heading: "Install New Panel" },
        React.createElement(PanelSearchView, { id: props.serviceId })));
};
var templateObject_1, templateObject_2;
